import { render, staticRenderFns } from "./PazientiProgettiListComponent.vue?vue&type=template&id=c8acf18a"
import script from "./PazientiProgettiListComponent.vue?vue&type=script&lang=js"
export * from "./PazientiProgettiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports